import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
export var ResponseStatus;
(function (ResponseStatus) {
    ResponseStatus["Error"] = "Error";
    ResponseStatus["Success"] = "Success";
})(ResponseStatus || (ResponseStatus = {}));
export const ResponseStatusMap = new Map([
    [ResponseStatus.Error, 'Global.Options.ResponseStatus.Error'],
    [ResponseStatus.Success, 'Global.Text.Success'],
]);
let ResponseStatusService = class ResponseStatusService {
    constructor(_translate) {
        this._translate = _translate;
        this._data = ResponseStatusMap;
    }
    list() {
        return this._data;
    }
    get(status) {
        const s = this._data.get(status);
        return s ? this._translate.instant(s) : s;
    }
    getStyleClass(status) {
        switch (status) {
            case ResponseStatus.Success:
                return 'text-success';
            case ResponseStatus.Error:
                return 'text-danger';
            default:
                return '';
        }
    }
    getBadgeClass(status) {
        switch (status) {
            case ResponseStatus.Success:
                return 'badge badge_success';
            case ResponseStatus.Error:
                return 'badge badge_danger';
            default:
                return 'badge badge_default';
        }
    }
};
ResponseStatusService.ctorParameters = () => [
    { type: TranslateService }
];
ResponseStatusService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [TranslateService])
], ResponseStatusService);
export { ResponseStatusService };
